import React from "react"
import {connect} from "react-redux"
import {Form as BootstrapForm} from "react-bootstrap"
import {Tooltip} from "@material-ui/core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons/faInfoCircle";
import BootstrapToggle from "react-bootstrap-toggle"
import {FormikProps} from "formik/dist/types"
import {
  changeRoutineStatusAction,
  resetSearchAction,
  setMissionAction,
} from "../../../state/application/actions"
import {
  changeRoutineStatusActionGeomap,
  removeKMLGuideShapeAction,
  removeLastShapeAction, setSearchMode,
} from "../../../state/geoMap/actions"
import {
  resetSearchAction as resetProductSearchAction
} from "../../../state/product/actions"
import {hasBeenFilled} from "../../../helpers/dynamicFormHelper"
import {AdvancedSearchConfigurationsType} from "../../../types/configurations"
import {ShapeType} from "../../../types/shape"
import {DEFAULT_TOOLTIP_PROPS} from "../../../helpers/tooltipHelper"
import translations from "../../../translations"

interface PropsType {
    scopeConfigurationFields: string,
    configurations: AdvancedSearchConfigurationsType,
    selectedArea: ShapeType,
    disabled: boolean,
    isInterferometricStackSearch: boolean,
    removeLastShapeActionHandler: any,
    removeKMLGuideShapeActionHandler: any,
    changeRoutineStatusHandler: any,
    changeRoutineStatusHandlerGeomap: any,
    setMissionActionHandler: any,
    resetSearchActionHandler: any,
    resetProductSearchActionHandler: any,
    formProps: FormikProps<any>,
    language: string,
    setSearchMode: any
}

const SearchModeField = (props: PropsType) => {
  const {
    disabled,
    removeLastShapeActionHandler,
    removeKMLGuideShapeActionHandler,
    resetSearchActionHandler,
    resetProductSearchActionHandler,
    setSearchMode,
    formProps,
    isInterferometricStackSearch,
    language,
  } = props

  const {values, setFieldValue} = formProps

  const value = values.search_mode
  const isInputDisabled =
        (disabled && hasBeenFilled(value)) || (values.routine && isInterferometricStackSearch)

  // @mapitaly: aggiunte possibili opzioni per il toggle tra routine e on demand
  let toggleOptions;
  if (values.routine) {
    toggleOptions = [
      translations("Standard", language),
      translations("TileID", language)
    ];
  } else {
    toggleOptions = [
      translations("Standard", language),
      translations("RecordNumber", language),
    ];
  }

  let switchElement = (
    <BootstrapToggle
      id="search_mode"
      name="search_mode"
      disabled={isInputDisabled}
      onClick={(search_mode) => {
        resetSearchActionHandler()
        resetProductSearchActionHandler()
        removeLastShapeActionHandler()
        removeKMLGuideShapeActionHandler()
        setSearchMode(search_mode);
        setFieldValue("search_mode", search_mode);
      }}
      off={toggleOptions[0]}
      onClassName="mode-switch-routine"
      on={toggleOptions[1]}
      offClassName="mode-switch-ondemand"
      handleClassName="container-mode-switch"
      active={value}
      height="28px"
      width="147px"
    />
  )

  if (isInputDisabled) {
    switchElement = (
      <Tooltip
        {...DEFAULT_TOOLTIP_PROPS}
        title={translations("searchModeNotAvaillable", language)}
        placement="top"
      >
        {switchElement}
      </Tooltip>
    )
  }

  return (
    <div className="row mx-0 mb-3">
      <BootstrapForm.Label className="col-3 m-0 px-0 d-flex">
        <Tooltip
          {...DEFAULT_TOOLTIP_PROPS}
          title={translations(isInputDisabled ? (values.routine ? "infoLabelSearchTypeInterferometrickDisabled" : "infoLabelSearchTypeInterferometrickDisabledOnDemand") : (values.routine ? "infoLabelSearchType" : "infoLabelSearchTypeOnDemand"), language)}
          placement="right-end"
        >
          <span className="title">
            <span style={{textOverflow: "inherit"}}>
              *
              {values.routine ? translations("searchModeLeftSearchBarRoutine", language) : translations("searchModeLeftSearchBarOnDemand", language)}
            </span>
            <FontAwesomeIcon
              icon={faInfoCircle}
              className="ml-1"
            />
          </span>
        </Tooltip>
      </BootstrapForm.Label>
      <BootstrapForm.Group className="col-9 m-0 pr-0 switch-container d-flex justify-content-end">
        {switchElement}
      </BootstrapForm.Group>
    </div>
  )
}

const mapStateToProps = (state) => ({
  configurations: state.application.configurations,
  selectedArea: state.geoMap.lastShape,
  loadingInitialData: state.application.loadingInitialData,
  isInterferometricStackSearch: state.product.isInterferometricStackSearch,
  language: state.application.appParameters.language
})

const mapDispatchToState = (dispatch) => ({
  setMissionActionHandler: (missionCodes) => dispatch(setMissionAction(missionCodes)),
  removeLastShapeActionHandler: () => dispatch(removeLastShapeAction()),
  removeKMLGuideShapeActionHandler: () => dispatch(removeKMLGuideShapeAction()),
  changeRoutineStatusHandler: (status) => dispatch(changeRoutineStatusAction(status)),
  changeRoutineStatusHandlerGeomap: (status) => dispatch(changeRoutineStatusActionGeomap(status)),
  resetSearchActionHandler: () => dispatch(resetSearchAction()),
  resetProductSearchActionHandler: () => dispatch(resetProductSearchAction()),
  setSearchMode: (search_mode) => dispatch(setSearchMode(search_mode)),
})

export default connect(mapStateToProps, mapDispatchToState)(SearchModeField)
